import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NavigationItemData } from '@/app/platform/platform-shared/models/navigation-item.data';

@Component({
    selector: 'egi-navigation-item',
    templateUrl: './egi-navigation-item.component.html',
    styleUrls: ['./egi-navigation-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EgiNavigationItemComponent implements OnInit {
  @Input() navigationItem: NavigationItemData;
  @Input() expanded: boolean;
  /**
   * Volledige link van de pagina (hash-URL met navId). Gezet → het label wordt
   * een echte link, zodat de browser bij rechtermuisklik "Openen in nieuw
   * tabblad" aanbiedt.
   */
  @Input() href: string | undefined;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  get icon(): string {
    return this.expanded ? 'chevron-down' : 'chevron-right';
  }

  ngOnInit(): void {}

  /**
   * Gewone klik: de standaardnavigatie van de link tegenhouden, de klik op het
   * menu-item (router + submenu sluiten) doet het werk. Met Ctrl/Cmd/Shift/Alt
   * opent de browser de link zelf (nieuw tabblad of venster); dan mag de klik
   * niet doorbubbelen, anders navigeert ook dit tabblad.
   */
  onLinkClick(event: MouseEvent): void {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
      event.stopPropagation();
      return;
    }
    event.preventDefault();
  }
}
